export type HolidayType = "milli_bayram" | "kasim10";

export type HolidayInfo = {
  type: HolidayType;
  name: string;
  showAtaturk: boolean;
};

const NATIONAL_HOLIDAYS: Array<{
  month: number;
  day: number;
  name: string;
  showAtaturk: boolean;
}> = [
  {
    month: 4,
    day: 23,
    name: "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı",
    showAtaturk: false,
  },
  {
    month: 5,
    day: 19,
    name: "19 Mayıs Atatürk'ü Anma, Gençlik ve Spor Bayramı",
    showAtaturk: true,
  },
  {
    month: 8,
    day: 30,
    name: "30 Ağustos Zafer Bayramı",
    showAtaturk: false,
  },
  {
    month: 10,
    day: 29,
    name: "29 Ekim Cumhuriyet Bayramı",
    showAtaturk: false,
  },
];

export function getActiveHoliday(): HolidayInfo | null {
  const now = new Date();
  const month = now.getMonth() + 1;
  const day = now.getDate();

  if (month === 11 && day === 10) {
    return { type: "kasim10", name: "10 Kasım", showAtaturk: true };
  }

  const holiday = NATIONAL_HOLIDAYS.find(
    (h) => h.month === month && h.day === day,
  );
  if (holiday) {
    return {
      type: "milli_bayram",
      name: holiday.name,
      showAtaturk: holiday.showAtaturk,
    };
  }

  return null;
}
